"use strict";

exports.__esModule = true;
exports.usePrismTheme = void 0;

var brand_1 = require("@apollo/brand");

var react_1 = require("@chakra-ui/react");

var _a = brand_1.colors.tokens,
    code = _a.code,
    bg = _a.bg,
    border = _a.border;

function usePrismTheme() {
  var isDark = (0, react_1.useColorModeValue)(false, true);
  return {
    plain: {
      color: "currentColor",
      backgroundColor: isDark ? bg.secondary.dark : bg.secondary.base
    },
    styles: [{
      types: ["deleted"],
      style: {
        color: isDark ? border.error.dark : border.error.base
      }
    }, {
      types: ["important", "bold"],
      style: {
        fontWeight: "bold"
      }
    }, {
      types: ["italic"],
      style: {
        fontStyle: "italic"
      }
    }, {
      types: ["entity"],
      style: {
        cursor: "help"
      }
    }, {
      types: ["selector", "attr-name", "char", "builtin", "inserted"],
      style: {
        color: isDark ? code.d.dark : code.d.base
      }
    }, {
      types: ["comment", "prolog", "doctype", "cdata"],
      style: {
        color: isDark ? code.b.dark : code.b.base,
        fontWeight: "bold"
      }
    }, {
      types: ["scalar", "attr-value"],
      style: {
        color: isDark ? code.c.dark : code.c.base
      }
    }, {
      types: ["url", "attr-value"],
      style: {
        color: isDark ? code.g.dark : code.g.base
      }
    }, {
      types: ["punctuation", "constant"],
      style: {
        color: isDark ? code.a.dark : code.a.base
      }
    }, {
      types: ["property", "tag", "boolean", "number", "symbol"],
      style: {
        color: isDark ? code.c.dark : code.c.base
      }
    }, {
      types: ["class-name"],
      style: {
        color: isDark ? code.a.dark : code.a.base
      }
    }, {
      types: ["property", "function"],
      style: {
        color: isDark ? code.d.dark : code.d.base
      }
    }, {
      types: ["atrule", "attr-value", "keyword"],
      style: {
        color: "inherit",
        background: "transparent"
      }
    }, {
      types: ["atrule", "attr-value", "keyword"],
      style: {
        color: isDark ? code.b.dark : code.b.base
      }
    }, {
      types: ["string"],
      style: {
        color: isDark ? code.g.dark : code.g.base
      }
    }, {
      types: ["regex", "important", "variable", "description", "comment", "prolog", "doctype", "cdata"],
      style: {
        color: isDark ? code.f.dark : code.f.base
      }
    }]
  };
}

exports.usePrismTheme = usePrismTheme;